// normalize css
import 'normalize.css/normalize.css';

// add typfaces font
import "typeface-raleway";
import "typeface-roboto";
import "typeface-roboto-slab";
import "typeface-questrial";

//code syntax color and line numbers
require('gatsby-remark-vscode/styles.css');
// require("prismjs/themes/prism-okaidia.css")
// require("prismjs/plugins/line-numbers/prism-line-numbers.css")